export default __webpack_public_path__ + "9e20118.png";